module.exports = __webpack_public_path__ + "zaw-confirmation-check.7b73713399e4fa5f2087cf46d96735ce.svg";